/**
 * Pure mutation functions for document property actions.
 */

import type {IDocumentData, IUserData} from "@buildwithflux/models";

import {currentAgentIsBot} from "helpers/isBot";
import {FluxLogger} from "modules/storage_engine/connectors/LogConnector";

/**
 * Updates the document timestamp and contributor list if the action has updatesDocumentTimestamp: true.
 * This is a cross-cutting concern that was previously handled at the end of the Redux reducer.
 */
export function applyTimestampUpdate(
    draft: IDocumentData,
    updatesDocumentTimestamp: boolean | undefined,
    currentUser: IUserData | undefined,
): void {
    if (currentAgentIsBot) {
        return;
    }

    if (!updatesDocumentTimestamp || !currentUser) {
        return;
    }

    // Update contributor list
    if (currentUser.uid) {
        const contributorExists = draft.contributor_uids?.find((userUid: string) => userUid === currentUser.uid);

        if (!contributorExists) {
            if (!draft.contributor_uids) {
                draft.contributor_uids = [];
            }

            draft.contributor_uids.push(currentUser.uid);
            draft.contributor_uids = draft.contributor_uids.filter((uid: string) => uid);
        }
    }

    // Update timestamp
    const now = new Date().getTime();
    if (now < draft.created_at) {
        FluxLogger.captureError(new Error("updated_at should never be less than created_at"));
    }
    if (now < draft.updated_at) {
        FluxLogger.captureError(new Error("New updated_at should never be less than old updated_at"));
    }

    draft.updated_at = now;
    draft.updated_by = currentUser.handle;
}
